import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "youtube-section health-coverage text-center"
};
const _hoisted_2 = {
  class: "secure-visa-custom-container section-margin"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "col-12"
};
const _hoisted_5 = {
  class: "mb-5"
};
const _hoisted_6 = {
  class: "video-container"
};
const _hoisted_7 = ["src", "title"];
export default {
  __name: 'youtubeSection',
  props: ['title', 'videoUrl'],
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h2", _hoisted_5, _toDisplayString(__props.title), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("iframe", {
        src: __props.videoUrl,
        title: __props.title,
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: ""
      }, null, 8, _hoisted_7)])])])])]);
    };
  }
};